module.exports = __webpack_public_path__ + "static/media/stop-17.b0b3f7b4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/stop-markers/alt-color/stop-17.svg
// module id = 1384
// module chunks = 0